import React from "react";
import "./style.css";
import { Link } from "react-router-dom";

const AboutScreen = () => {
  return (
    <div className="about-screen p-md-5 pt-4">
      <div className="head pt-lg-3 pb-3">
        <h3>About Happy Energy</h3>
      </div>
      <div className="about pt-2 pb-2">
        <div className="abouts pt-lg-4 pb-lg-4">
          <div className="col-lg-5 mt-md-5">
            <div className="about-img">
              <img
                className="w-100"
                src="./images/about.jpg"
                alt="Second slide"
              />
            </div>
          </div>
          <div className="col-lg-7">
            <div className="about-content">
              <h4>About Us</h4>
              <p className="pt-lg-4">
                Happy Energy Pvt. Ltd is registered at Office of the Company
                Registrar, Tripureshwor, Kathmandu, Nepal on 06 Jestha, 2075 (20
                May, 2018) as per the provisions of Companies Act, 2063 with an
                objective of identifying, assessing and developing technical and
                economically feasible Hydro Electric Projects on the various
                geographical location of the Nepal by utilizing water resources
                in an efficient and sustainable manner in order to produce
                electricity, reducing greenhouse gas emissions and combat
                climate change by providing a reliable and environment friendly
                energy source.
              </p>
              <div className="read-more pt-lg-5">
                <Link to="/about-business">
                  <button>Read More</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutScreen;
